import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../../auth/UseAuth'
import { useSettings } from '../../../hooks/useSettings'
import { languages } from '../../../types/constants'
import { useGetVersionQuery } from '../../../redux/api/staticApi'

export function UserMenuComponent() {
  const [visible, setVisible] = useState(false)
  const { user, manager } = useAuth()
  const { t, i18n } = useTranslation()
  const [currentLanguage, updateCurrentLanguage] = useSettings('lang')
  const version = useGetVersionQuery()

  useEffect(() => {
    i18n.changeLanguage(currentLanguage)
  }, [currentLanguage, i18n])

  return (
    <div className="userMenuArea" tabIndex={1} onBlur={() => setVisible(false)}>
      <i className="icon-settings" onClick={() => setVisible(!visible)}></i>
      {visible && (
        <div className="userMenu">
          {user ? (
            <div className="userInfo">
              <i className="icon-user" />
              <div>
                <div className="userRole">{user.displayName}</div>
                <span className="userMail">{user.email}</span>
              </div>
            </div>
          ) : null}
          {user ? (
            <a className="userInfo" onClick={() => manager.signoutRedirect()}>
              <i className="icon-key"></i> {t('SIGN_OUT')}
            </a>
          ) : (
            <a className="userInfo" onClick={() => manager.signinRedirect()}>
              <i className="icon-key"></i> {t('SIGN_IN')}
            </a>
          )}
          <ul className="langSel">
            {languages.map((lang, idx) => (
              <li key={idx}>
                {' '}
                <a onClick={() => updateCurrentLanguage(lang)} className={currentLanguage === lang ? 'active' : 'inactive'}>
                  {lang}
                </a>
              </li>
            ))}
          </ul>
          <span className="build-ver-container">build {`${version.data?.buildId}`}</span>
        </div>
      )}
    </div>
  )
}
